import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, viewChild } from '@angular/core';
import { intersection } from 'lodash-es';
import { RRol } from '@cumlaude/service-contract';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { CurrentUrlService } from '@cumlaude/shared-services';
import { UserService, rolOrder } from '../../services/user.service';
import { QueryParamStateService } from '../../services/query-param-state.service';
import { FilterService } from '../../services/filter.service';
import { HeaderActiesService } from '../../services/header-acties.service';
import { RolSwitcherComponent } from '../../startpagina/rol-switcher/rol-switcher.component';
import { ProfielMenuComponent } from '../header/profiel-menu/profiel-menu.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@Component({
	selector: 'app-paginakop',
	templateUrl: './paginakop.component.html',
	styleUrls: ['./paginakop.component.scss'],
	imports: [ButtonComponent, RolSwitcherComponent, ProfielMenuComponent, BreadcrumbComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginakopComponent {
	private readonly currentUrl = inject(CurrentUrlService);
	protected readonly userService = inject(UserService);
	private readonly qp = inject(QueryParamStateService);
	private readonly filterService = inject(FilterService);
	private readonly headerActies = inject(HeaderActiesService);

	private readonly feedbackButton = viewChild.required('feedbackButton', { read: ElementRef });

	protected readonly opStart = computed(() => this.currentUrl.currentPath() === '/start');

	protected readonly activeRol = this.userService.activeRol;
	protected readonly rollen = computed(() => intersection(rolOrder, this.userService.rollen() ?? []));

	changeRol(rol: RRol) {
		this.userService.changeRol(rol);
		this.qp.resetQueryParams().then(() => this.filterService.clearActiveNonDefault());
	}

	openFeedback() {
		this.headerActies.openFeedback(this.feedbackButton());
	}

	openHelp() {
		this.headerActies.openHelp();
	}
}
